import { toLonLat } from 'ol/src/proj';
import { getHeight, getWidth } from 'ol/src/extent';

import { fetchers, mapConfig } from 'shared';

import { renderStopHoverTooltip, renderStopSelectedTooltip } from './TooltipRenderer';
import { createMarker } from '../../utils';

let showMarkersValue;
let lastSelectedMarker = null;

/**
 *
 * @param {import('ol/src/Map').default} map
 * @param {boolean} showMarkers
 * @param {function} addPoint
 * @returns
 */
export default async function updateStopMarkers(map, showMarkers, addPoint, setStopMarkers) {
	showMarkersValue = showMarkers;

	const filteredMeans = ['1', '2', '3', '6'];

	if (showMarkers === false || map.getView().getZoom() < mapConfig.minZoomLevel.stops) {
		// If zoom is < 15 or markers should be hidden, remove all stop markers and stop further calculation etc.
		setStopMarkers([]);
		return;
	}

	const extent = map.getView().calculateExtent();
	const [lon, lat] = toLonLat(map.getView().getCenter());
	const width = getWidth(extent);
	const height = getHeight(extent);
	const diameter = Math.max(width, height);
	const radius = Math.ceil(diameter / 2);

	const stops = await fetchers.fetchCoords(lat, lon, radius);

	// Stop processing, if filter changed
	if (showMarkersValue === false) {
		return;
	}

	const newStopMarkers = [];

	stops.pins.forEach(stop => {
		// Check, if stop means is in filtered means
		if (!filteredMeans.some(entry => stop.attrs.STOP_MEANS_LIST.indexOf(entry) > -1)) {
			return;
		}

		const marker = createMarker(stop, {
			type: 'stop',
			state: 2,
			title: `${stop.desc}, ${stop.locality}`,
			desc: stop.desc,
			locality: stop.locality,
			vvsId: stop.attrs.STOP_GLOBAL_ID,
			vvsMeans: stop.attrs.STOP_MEANS_LIST,
			onHover: () => {
				// Only show hover tooltip if not selected
				if (!marker.get('selected')) {
					renderStopHoverTooltip(stop, marker, map);
				}
			},
			onClick: () => {
				// Clear previous selection
				if (lastSelectedMarker !== null && lastSelectedMarker !== marker) {
					lastSelectedMarker.set('selected', false);
					lastSelectedMarker.changed();
				}
				
				// Mark as selected and show selected tooltip with button
				marker.set('selected', true);
				marker.changed();
				lastSelectedMarker = marker;
				
				renderStopSelectedTooltip(stop, marker, map, addPoint);
			},
		});

		newStopMarkers.push(marker);
	});

	setStopMarkers(newStopMarkers);
}
